import useProfiler from "hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";
import { useEffect } from "react";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_2_step_ranker",
  stages: {
    main: 1, // SR
    meta: 2,
    direct: 3,
    oneWay: 4,
    return: 5,
    us: 6,
    solo: 7,
    nonSolo: 8
  },
  defaultStage: 1,
  mainStage: 1,
  goals: {
    clickedOnTopFiveOffers: 1,
    checkAndPayForTopFiveOffers: 2
  },
  goalsWithValue: []
});

// Tracking stages
const useTrackStages = (nonEmptyResults: boolean) => {
  const { stages } = utils;
  const { isDirect, isOneWay, isRountrip, isAmerican, isSolo } = useProfiler();

  useEffect(() => {
    if (!nonEmptyResults) return;

    stages.main();
    isDirect() ? stages.direct() : stages.meta();
    isOneWay() && stages.oneWay();
    isRountrip() && stages.return();
    isAmerican() && stages.us();
    isSolo() ? stages.solo() : stages.nonSolo();
  });
};

// Goal tracking for clickedOnTopFiveOffers
let didClickTopFive = false;
const trackClickedTopFive = () => {
  if (!didClickTopFive) {
    utils.goals.clickedOnTopFiveOffers();
    didClickTopFive = true;
  }
};

// Goal tracking for checkAndPayForTopFiveOffers
let didReachCP = false;
const trackCPTopFive = () => {
  if (!didReachCP) {
    utils.goals.checkAndPayForTopFiveOffers();
    didReachCP = true;
  }
};

export default { ...utils, useTrackStages, trackClickedTopFive, trackCPTopFive };
